import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export default function RequireRole({ role = "super_admin", children, fallback = "/login" }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div style={{ height: "100vh", display: "grid", placeItems: "center", background: "var(--pl-bg)" }}>
        <div style={{ color: "var(--pl-text-muted)", fontSize: 13, letterSpacing: "0.2em", textTransform: "uppercase" }}>
          Loading admin…
        </div>
      </div>
    );
  }
  const roles = (user?.roles) || [];
  if (!user) return <Navigate to={fallback} replace state={{ next: window.location.pathname }} />;
  if (!roles.includes(role)) return <Navigate to="/dashboard" replace />;
  return children;
}
